import Vue from 'vue'
import Vuex from 'vuex'

import alert from './modules/alert'
import user from './modules/user'
import jman from './modules/jman'
import dbsync from './modules/dbsync'
import tables from './modules/tables'
import dialogue from './modules/dialogue'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	modules: {
		alert,
		user,
		jman,
		dbsync,
		tables,
		dialogue
	},
	strict: debug
})




// WEBPACK FOOTER //
// ./src/store/index.js